export default function JobIntro() {
  return (
    <>
      <h2>About Paragraph</h2>
      <p>
        Paragraph is an onchain publishing & newsletter platform that
        provides creators with new and innovative ways of building communities,
        connecting with their audience, and monetizing their content. We're
        supercharging newsletters & publishing with onchain features:
        permanent & uncensorable storage; on-chain, portable social graphs;
        crypto payment rails; token-gated communities; wallet-to-wallet
        newsletters; and more.{" "}
      </p>
      <p>
        We're helping thousands of creators - from DAOs, to NFT communities, to
        traditional writers - and we're backed by some of the top investors in
        crypto.
      </p>
      <h2> How we work</h2>
      <h3>We're remote-first.</h3>
      <p>
        Remote work is the future, so we're committed to doing it right - and
        right from the start. The freedom to work remotely allows for deeper and
        more meaningful work, so we're a distributed team that places an
        emphasis on excellent asynchronous communication to collaborate. We're
        open to workers in North American timezones for now, but hope to support
        global work in the future.
      </p>
      <h3>We're product-focused and customer-obsessed.</h3>
      <p>
        We're building products that are simple, beautiful, and useful. We care
        deeply about the quality of our work - down to the last pixel - and we
        don't cut corners or make sacrifies to ship. We're passionate about
        building great software.
      </p>
      <h3>We firmly believe in good work-life balance.</h3>
      <p>
        People work their best when they're rested, happy, and fulfilled. Work
        on your own schedule with flexible work hours, and take as much vacation
        as you need to fully disconnect and recharge (Colin regularly takes 4+
        weeks vacation a year).
      </p>
      <h3>We offer competitive compensation & benefits.</h3>
      <p>
        We're early stage, but we believe good work should be rewarded. You'll
        have a 401k, medical & dental benefits, generous equity grants,
        competitive salary, and unlimited (truly unlimited) vacation.
      </p>
    </>
  )
}
